// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hawlucha: PokeData = {
  "id": 701,
  "name": "hawlucha",
  "height": 8,
  "weight": 215,
  "base_experience": 175,
  "types": [
    PokeType.FIGHTING,
    PokeType.FLYING
  ],
  "api_moves": [
    "karate-chop",
    "swords-dance",
    "wing-attack",
    "tackle",
    "submission",
    "high-jump-kick",
    "sky-attack",
    "detect",
    "encore",
    "taunt",
    "brick-break",
    "endeavor",
    "feather-dance",
    "aerial-ace",
    "bounce",
    "roost",
    "fling",
    "hone-claws",
    "sky-drop",
    "flying-press"
  ],
  "moves": [
    "karate-chop",
    "tackle",
    "sky-attack",
    "aerial-ace",
    "roost",
    "vacuum-wave",
    "air-slash",
    "gust",
    "rolling-kick",
    "drain-punch",
    "chatter",
    "meteor-assault",
    "peck"
  ],
  "evolution_chain": {
    "id": 359,
    "item": null,
    "species": [
      {
        "name": "hawlucha",
        "order": 701,
        "types": [
          PokeType.FIGHTING,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 104,
    "speed": 166,
    "ability_power": 130
  },
  "stat_changes": [],
  "catch_rate": 100,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
